import styled from "styled-components";

export const SponsorHeader = styled.h1`
    display: flex;
    font-family: Encode Sans ebold; 
    color: #00205B;
    text-align: center;
    justify-content: center;
    margin-bottom: 50px;
`

export const SponsorLink = styled.a`
    display: flex;
    margin: 2rem 6rem;

    @media screen and (max-width: 1200px) { 
        margin: 2rem 3rem;
    }

    @media screen and (max-width: 960px) { 
        margin: 2rem 2.2rem;
    }

    @media screen and (max-width: 460px) { 
        /* max-width: 50%; */
        margin: 2rem 10px;
        height: auto;
        justify-content: center;
    }
`

export const SponsorKiloLogo = styled.img `
    height: 65px;

    
    @media screen and (max-width: 980px) { 
        height: 60px;
    }
    @media screen and (max-width: 460px) { 
        width: 100px;
        height: auto;
        /* margin: 30px 0; */
    }
`
export const SponsorKiloSquareLogo = styled.img `
    height: 75px;

    
    @media screen and (max-width: 980px) { 
        height: 65px;
    }
    @media screen and (max-width: 460px) { 
        width: 50px;
        height: auto;
        /* margin: 30px 0; */
    }
`



export const SponsorKiloWideLogo = styled.img `
    height: 50px;

    
    @media screen and (max-width: 980px) { 
        height: auto;
        width: 150px;
    }
    @media screen and (max-width: 460px) { 
        width: 100px;
        height: auto;
        /* margin: 30px 0; */
    }
`


export const SponsorMegaWideLogo = styled.img `
    height: 45px;
    
    @media screen and (max-width: 980px) { 
        height: auto;
        width: 180px;
    }
    @media screen and (max-width: 460px) { 
        width: 120px;
        height: auto;
        /* margin: 30px 0; */
    }
`
export const SponsorMegaLogo = styled.img `
    height: 75px;
    
    @media screen and (max-width: 980px) { 
        height: 70px;
    }
    @media screen and (max-width: 460px) { 
        width: 115px;
        height: auto;
        /* margin: 30px 0; */
    }
`
export const SponsorMegaSquareLogo = styled.img `
    height: 80px;

    
    @media screen and (max-width: 980px) { 
        height: 70px;
    }
    @media screen and (max-width: 460px) { 
        width: 65px;
        height: auto;
        /* margin: 30px 0; */
    }
`



export const SponsorGigaLogo = styled.img `
    /* width: 400px; */
    height: 80px;

    
    @media screen and (max-width: 980px) { 
        width: 300px;
        height: auto;

    }
    @media screen and (max-width: 460px) { 
        width: 145px;
        /* margin: 10px 0; */
    }
`

export const SponsorTeraLogo = styled.img `
    width: 500px;
    
    @media screen and (max-width: 980px) { 
        width: 400px;
    }
    @media screen and (max-width: 460px) { 
        width: 350px;
        margin: 30px 0;
    }
`

export const SponsorGrid = styled.div`
    display: flex;
    padding: 1rem 0;
    align-items: center;
    flex-wrap: wrap;
    justify-content: center;
    /* border: 3px solid #00205B; */
    color: #00205B;
    border-radius: 15px;
    text-align: center;
    text-decoration: underline; 
    margin-bottom: 2rem;
`
export const SponsorContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 100px;
`